import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { Bars } from 'react-loader-spinner';
import { Link } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../utils/helpers';

const PlanCard = ({ 
  id, 
  name, 
  price, 
  billable, 
  description, 
  features, 
  stripe_price, 
  onBuy, 
  loader, 
  discounted_amount,
  isAuthenticated = false
}) => (
  <div className="bg-white rounded-xl shadow-md p-4 cursor-pointer border border-blue-100 my-2 flex flex-col h-full">
    <div>
      <h3 className="text-lg font-bold text-gray-900">{capitalizeFirstLetter(name)}</h3>
      <div className="flex items-baseline mt-1">
        <h3 className="text-xl font-semibold text-blue-600">
          ${price}
        </h3>
        <span className="text-sm text-gray-600 ml-1">/ {billable}</span>
      </div>
      {discounted_amount > 0 && (
        <p className="text-sm text-gray-500 line-through">${discounted_amount} / {billable}</p>
      )}
      <p className="text-sm text-gray-600 mt-2">{capitalizeFirstLetter(description)}</p>
      <div className="mt-3">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-center text-gray-700 text-xs mt-1">
            <FaCheckCircle className="mr-2 text-blue-500 flex-shrink-0" />
            <span>{feature}</span>
          </div>
        ))}
      </div>
    </div>
    <div className='mt-auto pt-4 w-full'>
      {isAuthenticated ? (
        <button
          onClick={onBuy}
          className="bg-blue-500 text-white px-4 rounded-md text-sm w-full h-8 flex items-center justify-center">
          {loader ? (
            <>
            <span>Loading</span>
            <Bars
              height="15"
              width="40"
              color="#FFFFFF"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
            </>
          ) : 'Subscribe'}
        </button>
      ) : (
        <Link to='/login'>
          <button className="bg-blue-500 text-white py-2 h-8 rounded-md text-sm w-full">
            Subscribe
          </button>
        </Link>
      )}
    </div>
  </div>
);

export default PlanCard; 